// extracted by mini-css-extract-plugin
export default {"lds-facebook":"style_lds-facebook__9emMs"};